import {createFileRoute, Navigate} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/cricket/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/cricket/leagues/" />;
}
